import {JsonServiceClient} from "@servicestack/client";

import {
    GetSalesforceInfoRequest,
    CreateStagedCandidateRequest,
    UpdateStagedCandidateRequest,
    DeleteStagedCandidateRequest,
    GetStagedCandidateRequest,
    GetStagedCandidatesRequest,
    GetSalesforceCandidateRequest,
    GetLookupRequest,
    GetCandidateDuplicatesRequest,
    GetStagedCandidateCvRequest
} from './sthree.service.consultant.dtos.ts';

const client = new JsonServiceClient(process.env.VUE_APP_API || 'https://localhost:5001');
client.credentials="omit";

export const setAuth = (token, user) => {
    client.headers.set("Authorization", `Salesforce ${token}:${user}`);
}

export const setCorsHeaders = () => {
    client.mode = 'cors';
};

export const getSalesforceInfo = () => {
    const req = new GetSalesforceInfoRequest();
    return client.get(req);
};

export const createStagedCandidate = (uploadModel) => {
    const req = new CreateStagedCandidateRequest();
    req.UploadedById = uploadModel.uploadedById;
    req.ForCandidateId = uploadModel.externalId;
    req.Source = uploadModel.source;
    req.Brand = uploadModel.brand;
    req.FileExt = uploadModel.ext;
    req.FileContent = uploadModel.content;
    req.ForJobId = uploadModel.forJobId;
    return client.put(req);
};

export const updateStagedCandidate = (candidate, commit) => {
    const req = new UpdateStagedCandidateRequest ();
    //req.Source = candidate.cvSource;
    req.Id = candidate.id;
    req.Brand = candidate.brand;
    req.ExternalId = candidate.forCandidateId;
    req.Salutation = candidate.salutation;
    req.Forename = candidate.forename;
    req.Surname = candidate.surname;
    req.Email = candidate.email;
    req.Telephone = candidate.telephone;
    req.Mobile = candidate.mobile;
    req.Street = candidate.street;
    req.City = candidate.city;
    req.Province = candidate.province;
    req.CountryCode = candidate.country;
    req.Country = candidate.countryName;
    req.PostalCode = candidate.postalCode;
    req.JobTitle = candidate.jobTitle;
    req.EmploymentType = candidate.employmentType;
    req.ContactLanguage = candidate.language;
    req.DateOfBirth = candidate.dateOfBirth;
    req.CommitToExternal = commit;
    return client.post(req);
}

export const deleteStagedCandidate = (candidateId) => {
    const req = new DeleteStagedCandidateRequest();
    req.CandidateId = candidateId;
    return client.delete(req);
};

export const getStagedCandidate = (candidateId, externalId) => {
    const req = new GetStagedCandidateRequest();

    var id = parseInt(candidateId);

    if(Number.isInteger(id)){
        req.CandidateId = candidateId;
    }else{
        req.CandidateId = null;
    }
    
    if (externalId){
        req.externalId = externalId;
    }
    return client.get(req);
};

export const getStagedCandidateList = (userId, externalId, take, skip) => {
    const req = new GetStagedCandidatesRequest();
    req.userId = userId;
    req.externalId = externalId;
    req.take = take;
    if (skip) {
        req.skip = skip;
    }
    return client.get(req);
};

export const getSfCandidate = (salesforceId) => {
    const req = new GetSalesforceCandidateRequest();
    req.salesforceId = salesforceId;
    return client.get(req);
};

export const getLookup = (type, parentId, userId) => {
    const req = new GetLookupRequest();
    req.lookupType = type;
    if (parentId){
        req.parentId = parentId;
    }
    if (userId){
        req.userId = userId;
    }
    return client.get(req);
}

export const getDuplicates = (candidate) => {
    const req = new GetCandidateDuplicatesRequest();
    req.Brand = candidate.brand;
    req.Email = candidate.email;
    req.FirstName = candidate.forename;
    req.LastName = candidate.surname;
    return client.get(req);
}

export const getStagedCandidateCv = (candidateId) => {
    const req = new GetStagedCandidateCvRequest();
    req.candidateId = candidateId;
    return client.get(req);
}
